export const searchName = (search) => {
  const searchTerms = search
    .trim()
    .split(" ")
    .filter((term) => term);
  return (
    searchTerms.length > 0 && {
      _or: searchTerms.map((term) => ({
        _or: [
          { first_name: { _contains: term } },
          { last_name: { _contains: term } },
        ],
      })),
    }
  );
};
